import { Component, OnInit } from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {ListPage} from "../list/list";
import {DataProvider} from "../../providers/data/data";

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage implements OnInit {

  public orders_table = [];
  selectedItem: any;

  constructor(public navCtrl: NavController, public http: HttpClient, public navParams: NavParams, public data: DataProvider) {}

  ngOnInit() {
    this.selectedItem = this.navParams.get('item');
    this.loadList();
  }

  loadList() {
    const body = {
      token: localStorage.getItem('token'),
      module: 'orders',
      submodule: 'device_list',
    };
    this.http.post(environment.api_url, body).subscribe(daten => {
        this.orders_table = daten['data'];
      }, error => {
      }
    );
  }

  start(event, i) {
    this.navCtrl.push(HomePage, {
      item: i
    });
  }


  open(event, i) {
    this.navCtrl.push(ListPage, {
      item: i
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts